<template>
  <v-card-subtitle class="pt-2 d-flex">
    <v-icon
      v-text="'fas fa-location-arrow'"
      color="text--secondary"
      size="16"
      class="ml-1 mr-2"
    ></v-icon>

    <!-- DISPLAY DISTANCE FROM SEARCH POINT TO THE DESTINATION -->
    <div
      v-if="
        /city|poi|locality|place|neighborhood|address/.test(searchPlaceType)
      "
    >
      <span v-if="distance > 0"
        >{{ distance }} km de {{ searchShortName }}
      </span>
      <span v-else>Moins d' 1 km de {{ searchShortName }}</span>
    </div>

    <!-- DISPLAY DISTANCE FROM CLIENT POSITION TO THE DESTINATION -->
    <div
      v-else-if="
        /range|bbox|myPosition|department|region|administrative|country/.test(
          searchPlaceType
        )
      "
    >
      <span v-if="distance > 0">{{ distance }} km </span>
      <span v-else>Moins d' 1 km {{ searchShortName }}</span>
    </div>
  </v-card-subtitle>
</template>

<script>
export default {
  // COMPONENT NAME
  name: "SearchDestinationCardDistanceInformation",
  // DATAs
  props: {
    distance: {
      type: Number,
      required: true
    },
    searchPlaceType: {
      type: String,
      required: true
    },
    searchShortName: {
      type: String,
      required: true
    }
  }
};
</script>
